import styled, {css} from 'styled-components';

const Styled = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  
    .anticon {
        font-size: 12px;
    }

    span {
        color: white;
        cursor: pointer;
    }
`;

const LogoStyled = css`
    /* Jye refactored */
    .ant-dropdown-menu.menu-company-dropdown {
        width: 300px;

        .ant-dropdown-menu-item {
            .input-search-companies {
                width: calc(300px - 24px);
            }
        }

        .ant-dropdown-menu-item-group.company-dropdown-scrollable {
            max-height: 70vh;
            overflow: auto;
          
            .ant-dropdown-menu-item-group-title {
                padding: 0;
            }
          
            .ant-dropdown-menu-item-group-list {
                margin: 0;

                .ant-dropdown-menu-item {
                    .ant-col.legal-name {
                        width: 100px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .ant-tag {
                        margin-right: 0;
                    }
                }
            }
        }
    }

    /* End of refactored */

    .company-search.ant-dropdown-menu-item {
        padding: 0 !important;
        cursor: default !important;
      
        .content {
            padding: 5px 9px;
        }
    }
  
    .divider-container {
        padding: 0;
        cursor: default !important;
      
        .divider {
          padding: 5px 0;
          
          .ant-divider.ant-divider-horizontal {
            margin: 0;
          }
        }
    }
    
  
    .ant-dropdown-menu-item:hover.divider-container {
        background-color: white;
    }


`;

export {Styled, LogoStyled};
